const s = {
  name: "Receipt2",
  dimensions: { width: 26, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 26 40" style="enable-background:new 0 0 26 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M0,0h26v40h-2V2H2v38H0V0z"/>
		<path class="st0" d="M21,7H5V5h16V7z"/>
		<path class="st0" d="M5,25h10v-2H5V25z"/>
		<path class="st0" d="M21,25h-3v-2h3V25z"/>
		<path class="st0" d="M5,20h10v-2H5V20z"/>
		<path class="st0" d="M21,20h-3v-2h3V20z"/>
		<path class="st0" d="M5,30h10v-2H5V30z"/>
		<path class="st0" d="M21,30h-3v-2h3V30z"/>
		<path class="st0" d="M5,35h10v-2H5V35z"/>
		<path class="st0" d="M21,35h-3v-2h3V35z"/>
		<path class="st0" d="M5,40h10v-2H5V40z"/>
		<path class="st0" d="M21,40h-3v-2h3V40z"/>
		<path class="st0" d="M8,12h10v-2H8V12z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as Receipt2
};
